module.exports = __webpack_public_path__ + "img/logo.ccafc212.png";